import { Figure as FigureCore } from '@studiometa/ui';

/**
 * Figure component
 * @param  {Class} Figure
 * @returns {void}
 */
export default class Figure extends FigureCore {
  static config = {
    name: 'Figure',
  };

  /**
   * Destroy the component on load.
   */
  onLoad() {
    this.$destroy();
  }
}
